import { render, staticRenderFns } from "./CreateStudySet.vue?vue&type=template&id=12b91498&scoped=true&"
import script from "./CreateStudySet.vue?vue&type=script&lang=js&"
export * from "./CreateStudySet.vue?vue&type=script&lang=js&"
import style0 from "./CreateStudySet.vue?vue&type=style&index=0&id=12b91498&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12b91498",
  null
  
)

export default component.exports